<template>
  <div>
    <v-row
      no-gutters
      align="center"
      class="mb-1"
    >
      <v-col>
        <div class="subtitle-1">
          {{ category.text }}
        </div>
      </v-col>
      <v-col cols="auto">
        <v-btn
          :text="!categoryChecked"
          :color="!categoryChecked ? 'error' : 'success'"
          class="text-capitalize"
          @click="toggleLogisticsChecklist(!categoryChecked)"
        >
          <v-icon
            left
            small
          >
            {{ !categoryChecked ? 'close' : 'check' }}
          </v-icon>
          {{ !categoryChecked ? 'Not Done' : 'Done' }}
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="elevation-10 radius-10">
      <v-card-text class="pa-0">
        <v-simple-table>
          <thead class="v-data-table-header theme--light">
            <tr>
              <th
                style="width: 50px"
              >
                ID
              </th>
              <th>
                Name
              </th>
              <th style="width: 1px">
                Added By
              </th>
              <th style="width: 1px">
                Added
              </th>
              <th style="width: 1px" />
            </tr>
          </thead>
          <tbody v-if="files.length > 0">
            <tr
              v-for="file in files"
              :key="file.id"
              class="grey lighten-4"
            >
              <td>
                <v-progress-circular
                  v-if="file.active"
                  color="grey"
                  :size="26"
                  :width="2"
                  indeterminate
                />
              </td>
              <td colspan="3">
                {{ file.name }}
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr v-if="documents.length === 0">
              <td
                class="grey--text"
                colspan="5"
              >
                There are no documents for this step.
              </td>
            </tr>
            <template v-for="document in documents">
              <tr :key="document.id">
                <td>
                  {{ document.id }}
                </td>
                <td class="pa-0">
                  <div class="font-weight-bold">
                    <a
                      href="#"
                      class="pa-3"
                      style="display: block"
                      @click.prevent="openDocument(document.file.id)"
                    >
                      {{ document.title }}
                    </a>
                  </div>
                </td>
                <td class="text-no-wrap">
                  <span v-if="document.user">
                    {{ document.user.name || (document.user.owner ? document.user.owner.name : '') }}
                  </span>
                  <span
                    v-else
                    class="grey--text"
                  >
                    n/a
                  </span>
                </td>
                <td class="text-no-wrap">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ document.created_at | moment('from') }}
                      </span>
                    </template>
                    {{ document.created_at | moment('D MMM YYYY HH:mm:ss') }}
                  </v-tooltip>
                </td>
                <td style="width: 1px">
                  <v-btn
                    v-if="$can('delete-all-documents', 'Document') || document.user_id === $store.state.auth.user.id"
                    icon
                    small
                    color="red"
                    @click="triggerDelete(document)"
                  >
                    <v-icon small>
                      close
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <tr style="height: auto">
              <td
                colspan="4"
              >
                <file-upload
                  :ref="'upload'+category.key"
                  :key="'upload'+category.key"
                  v-model="files"
                  :input-id="'file'+category.key"
                  :post-action="uploadUrl"
                  multiple
                  :data="{ type: 'logistics', logistics_type: category.key, yacht_id: yacht.id }"
                  :headers="{ 'Authorization': 'Bearer ' + $store.state.auth.token, 'Accept': 'application/json' }"
                  style="cursor: pointer"
                  @input-file="inputFile"
                >
                  <v-btn
                    color="primary"
                    class="text-none ma-0"
                    outlined
                    small
                  >
                    <v-icon
                      left
                      small
                    >
                      add
                    </v-icon>
                    Upload Documents
                  </v-btn>
                </file-upload>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      text="Are you sure you want to delete the document?"
      @confirmed="deleteDocument()"
    />
  </div>
</template>
<script>
import File from '@/models/File'
import VueUploadComponent from 'vue-upload-component'
import Yacht from '@/models/Yacht'
import Document from '@/models/Document'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog.vue'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'

export default {
  name: 'LogisticsChecklistCategory',
  components: {
    ConfirmDeleteDialog,
    FileUpload: VueUploadComponent
  },
  mixins: [ deleteConfirmationMixin ],
  props: {
    category: {
      type: Object,
      required: true
    },
    documents: {
      type: Array,
      required: true
    },
    yacht: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      files: [],
      documentToDelete: null
    }
  },
  computed: {
    categoryChecked() {
      if (!this.yacht.logistics_checklist) return false

      return this.yacht.logistics_checklist[this.category.key] || false
    }
  },
  created() {
    this.uploadUrl = process.env.VUE_APP_API_URL + '/documents/upload'
  },
  methods: {
    openDocument(fileId) {
      File.api.openDocument(fileId)
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        this.$refs['upload' + this.category.key].update(newFile, { active: true })
        return
      }

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data

        this.$refs['upload' + this.category.key].remove(newFile)
        this.documents.unshift(newFile.response)
      }
    },
    async toggleLogisticsChecklist(done) {
      let response = await Yacht.api.toggleLogisticsChecklist(this.yacht.id, this.category.key, done)

      if (!response.success) return

      this.$emit('update:yacht', response.yacht)
    },
    triggerDelete(document) {
      this.documentToDelete = document
      this.deleteConfirmationDialogVisible = true
    },
    async deleteDocument() {
      this.deleting = true

      try {
        await Document.api.delete(this.documentToDelete.id)

        this.$store.dispatch('alert', {
          text: 'Document deleted',
          color: 'success'
        })

        this.$emit('deleted', this.documentToDelete.id)
      } catch (e) {
        throw e
      } finally {
        this.deleting = false
        this.deleteConfirmationDialogVisible = false
      }
    }
  }
}
</script>

<style type="text/css">
 .file-uploads label {
   cursor: pointer;
 }
</style>
